function clockToMs(formatedTime: string) {
  const [minutes, seconds] = formatedTime.split(':');
  return parseInt(minutes) * 60000 + parseInt(seconds) * 1000;
}

export default clockToMs;
